import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CronjobLogs from "../../../modal/Monitoring_Tools/Cronjob_monitor/Cronjob_logs";
import Clear from "../../../modal/Monitoring_Tools/Cronjob_monitor/Clear";

import LoadingComponent from '../../../layouts/nav/loading';

const CronjobMonitor = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const [loading, setLoading] = useState(false);

    // page table data fetch
    const fetchData = () => {
        setLoading(true);
        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
        };
        axios.get(`${baseURL}/cronjob_monitor`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();

        // set interval to refetch every 1 minute (60000 ms)
        const interval = setInterval(() => {
            fetchData();
        }, 10000);

        // cleanup interval when component unmounts or deps change
        return () => clearInterval(interval);
    }, [page, searchTerm, perPage]);

    // datatable
    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);

    // display func
    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    // update status
    const handleStatusToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/cronjob_monitor/status/${id}`, { status: newStatus })
            .then(response => {
                toast.success("Status Updated Successfully!");
                fetchData();
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Updation Failed");
            });
    };

    // popup models
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [selecteddata, setSelecctedID] = useState({});
    const handleModalToggle_History = (data) => {
        setSelecctedID(data);
        setModalType("History");
        setOpen(true);
    };

    const handleModalToggle_Clear = () => {
        setModalType("Clear");
        setOpen(true);
    };

    const runCronApi = (data) => {
        fetchData();
        axios.get(`${data.cronjb_link}`)
            .then(response => {
                console.log("executed successfully");
            })
            .catch(error => {
                console.log('There was an error in cron execution!', error);
            });
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Cronjob Monitor</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Monitoring Tools</li>
                    </ol>
                </div>

                <button className="btn btn-primary float-end btn-sm" onClick={handleModalToggle_Clear}>
                    <span className='me-2'><i className="fa-solid fa-trash fs-8"></i></span>
                    <span className=''>Clear</span>
                </button>

                {open && modalType === "Clear" && (
                    <Clear show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "History" && (
                    <CronjobLogs show={open} onClose={() => setOpen(false)} data={selecteddata} />
                )}
            </div>

            <LoadingComponent loading={loading} />

            <Row>
                <Col xl={12}>
                    <div className="table-container">

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Left: Show entries dropdown */}
                            <div>
                                <label className="me-2">Show</label>
                                <select
                                    className="form-select d-inline w-auto"
                                    style={{ fontSize: '0.85rem', height: '30px' }}
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(Number(e.target.value));
                                        setPage(1); // Reset to first page
                                    }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>

                            {/* Right: Search input */}
                            <div>
                                <input
                                    type="text"
                                    style={{ fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(1); // Reset page on new search
                                    }}
                                />
                            </div>
                        </div>

                        <table style={{ borderBottom: '2px solid #ddd' }} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-25px'>Sno</th>
                                    <th className='min-w-100px'>Cronjob</th>
                                    <th className='min-w-110px'>Cronjob Duration</th>
                                    <th className='min-w-100px'>Cronjob Status</th>
                                    <th className='min-w-100px'>Last Run Duration</th>
                                    <th className='min-w-100px'>Status</th>
                                    <th className='min-w-100px'>Action</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {datas.length === 0 && hasFetched ? (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-2">
                                            No data available
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {datas.map((data, index) => (
                                            <tr key={data.sno}>
                                                <td className='text-start align-content-center'>
                                                    <label className='text-black fw-semibold font-w400 fs-7'>{index + 1}</label>
                                                </td>
                                                <td className='align-content-center'>
                                                    <div className="d-flex align-items-center text-black fw-semibold fs-6 text-wrap mw-75">
                                                        <span>{capitalizeFirstLetter(data.cronjob_name)}</span>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                            overlay={
                                                                <Tooltip className="toltip-popover">
                                                                    <span className="fs-8 text-white fw-semibold">{data.cronjob_desc}</span>
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Button variant="tp-btn-light px-2 py-1 ms-2" style={{ color: 'black' }}>
                                                                <i className="fa-solid fa-circle-question fs-6 mt-1"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                                <td className='align-content-center'>
                                                    <div className='text-black fw-semibold font-w400 fs-7 text-wrap mw-75'>{data.cronjob_run_duration}</div>
                                                </td>
                                                <td className='align-content-center'>
                                                    {data.running_status ? (
                                                        <Badge bg="success" className="py-1 px-2 fs-8 d-inline-flex align-items-center">
                                                            <span className="me-1 spinner-dot"></span>
                                                            Running
                                                        </Badge>
                                                    ) : (
                                                        <Badge bg="danger" className="py-1 px-2 fs-8">Stopped</Badge>
                                                    )}
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                        overlay={
                                                            <Tooltip className="toltip-popover">
                                                                <span className="fs-8 text-white fw-semibold">Start: {data.formatted_start_time} <br></br> End: {data.formatted_end_time} <br></br>Duration: {data.sync_duration}</span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Button variant="tp-btn-light px-2 py-1 ms-2" style={{ color: 'black' }}>
                                                            <i className="fa-solid fa-business-time fs-6 mt-1"></i>
                                                        </Button>
                                                    </OverlayTrigger>
                                                </td>
                                                <td className='align-content-center'>
                                                    <Badge bg="info" className='py-1 px-2 fs-8' >{data.formatted_duration}</Badge>
                                                </td>
                                                <td className='align-content-center'>
                                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                                        <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked={data.status === 0} onChange={() => handleStatusToggle(data.sno, data.status)} />
                                                    </div>
                                                </td>
                                                <td className='align-content-center'>
                                                    <span className="text-start">
                                                        <Badge bg={data.running_status === 0 ? "primary" : "info"}
                                                            className={`py-1 px-2 fs-8 ${data.running_status === 1 ? "disabled" : "cursor-pointer"}`}
                                                            onClick={() => data.running_status === 0 && runCronApi(data)}
                                                            style={{ pointerEvents: data.running_status === 0 ? "auto" : "none" }}
                                                        >
                                                            Run Now
                                                        </Badge>

                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                            overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Run History</span> </Tooltip>}>
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_History(data)}>
                                                                <span><i className="fa-solid fa-clock-rotate-left fs-4 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>

                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                            </tbody>
                        </table>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {/* Bottom left: Showing x to y of z entries */}
                            <div>
                                {datas.length > 0 ? (
                                    <span className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                    </span>
                                ) : (
                                    <span className="text-muted">
                                        Showing 0 to 0 of 0 entries
                                    </span>
                                )}
                            </div>

                            {/* Bottom right: Pagination */}
                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                    </div>
                </Col>
            </Row>


        </>
    )

}
export default CronjobMonitor;